import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http'
import { Injectable, NgZone } from '@angular/core'
import { Router } from '@angular/router'
import { noop, Observable, throwError } from 'rxjs'
import { catchError, filter } from 'rxjs/operators'
import { appConfig } from '../../../brands/_current/config/app-config'
import { AccountErrorCodeEnum } from '../../shared/mycicero-web-api/shared/base-login-output.model'
import { isBaseOutput } from '../../shared/mycicero-web-api/shared/base-output.model'

@Injectable()
export class UnauthorizedInterceptor implements HttpInterceptor {
  constructor(
    private readonly router: Router,
    private readonly zone: NgZone,
  ) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      filter(() => request.url.includes(appConfig.myCiceroWebApi.urls._base)),
      catchError((error) => {
        if (error instanceof HttpErrorResponse && isBaseOutput<AccountErrorCodeEnum>(error.error)) {
          const codeError = error.error.CodeError
          if (codeError === AccountErrorCodeEnum.unauthorized) {
            this.zone
              .run(() =>
                this.router.navigate([appConfig.feedback.paths._root, appConfig.feedback.paths.sessionExpired], {
                  queryParamsHandling: 'merge',
                  replaceUrl: true,
                }),
              )
              .then(noop)
          }
        }
        return throwError(() => error)
      }),
    )
  }
}
